import { useNavigate } from "react-router";
import { NavBar } from "../components/Navigation/NavBar";

export default function RootLayout({
  children,
  title,
}: Readonly<{
  children: React.ReactNode;
  title?: string;
}>) {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;

  return (
    <div className="min-h-screen flex">
      <div className="bg-[#1C0C40] w-64">
        <section className="flex justify-center py-5">
          <img src="/logo/fvlogo.png" alt="logo" className="w-36" />
        </section>
        <section className="space-y-1 pl-6">
          <div
            className={`text-white flex gap-3 hover:bg-[#311b64] duration-500 cursor-pointer py-2 rounded-lg px-2 w-48 ${
              currentPath === "/dashboard/" && "bg-slate-700"
            }`}
            onClick={() => {
              navigate("/dashboard/");
            }}
          >
            <img src="/icons/banner.png" alt="logo" className="w-6" />
            <span>Banners Manager</span>
          </div>
          <div
            className={`text-white flex gap-3 hover:bg-[#311b64] duration-500 cursor-pointer py-2 px-2 w-48 rounded-lg ${
              currentPath.includes("/dashboard/users") && "bg-slate-700"
            }`}
            onClick={() => {
              navigate("/dashboard/users");
            }}
          >
            <img src="/icons/user.png" alt="logo" className="w-6" />
            <span>Users Manager</span>
          </div>
        </section>
      </div>
      <div className="w-full">
        <div className="bg-white shadow-xl h-16 flex justify-center items-center">
          <div className="font-semi-bold text-2xl text-gray-400">{title}</div>
        </div>
        <div className="flex-1 bg-[#e9ebee] h-[90vh]">{children}</div>
      </div>
    </div>
  );
}
